module.exports = __webpack_public_path__ + "static/media/img_51.ecd23720.png";